import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Hero from './components/Hero';
import TechCards from './components/TechCards';
import DataChain from './components/DataChain';
import Cta from './components/Cta';

export default function Tech() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="核心技术 | TOMA智能体 · 数字货架 · 物联网连接"
        description="华辉数智三大核心技术能力：TOMA智能体、数字货架与云铺、物联网连接，构成县域数字商业基础设施。"
        keywords="核心技术,TOMA智能体,数字货架,物联网连接,县域数字商业"
        path="/tech"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'TechArticle',
          headline: '核心技术',
          about: 'TOMA智能体、数字货架与云铺、物联网连接',
        }}
      />
      <main>
        <Hero />
        <TechCards />
        <DataChain />
        <Cta />
      </main>
      <Footer />
    </div>
  );
}